import { render, staticRenderFns } from "./editPaxelMarketJoinProcedure.vue?vue&type=template&id=bc284c6e&"
import script from "./editPaxelMarketJoinProcedure.vue?vue&type=script&lang=js&"
export * from "./editPaxelMarketJoinProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports